module.exports = __webpack_public_path__ + "1697a94b56fa8f394e4c1ff13ef8143b.png";